/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { TopicFormDialog } from '../../components/forms/TopicForm/TopicFormDialog';
import { useFetch } from '../../hooks/useFetch';
import { getCellStatus } from '../../utils/FormatFunctions';

export function TopicsPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/rating/topics`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { requestApi: fetchTopic } = useFetch(baseUrl);
  const navigate = useNavigate();
  const location = useLocation();
  const { itemId } = useParams();
  const [dialog, setDialog] = useState<{ open: boolean; item: any | null }>({
    open: false,
    item: null,
  });
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (location.pathname.endsWith('/create')) {
      setDialog({ open: true, item: null });
      return;
    }
    if (itemId) {
      fetchTopic('get', undefined, `${baseUrl}/${itemId}`).then((res: any) => {
        if (res?.data?.data) setDialog({ open: true, item: res.data.data });
      });
    }
  }, [location.pathname, itemId]);

  const closeDialog = () => {
    setDialog({ open: false, item: null });
    if (location.pathname !== '/topics') navigate('/topics', { replace: true });
  };

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'name', label: 'Título' },
    { name: 'position', label: 'Posição' },
    { name: 'status', label: 'Status' },
  ];

  return (
    <Box>
      <PageTitle description="Organize os tópicos avaliados nas jornadas dos alunos.">
        Tópicos
      </PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate
        loading={loading}
        refreshKey={refreshKey}
        onCreate={() => setDialog({ open: true, item: null })}
        onEdit={(item) => setDialog({ open: true, item })}
        rowActions={{ show: false, edit: true, delete: true }}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
        formatColum={[
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
      />

      <TopicFormDialog
        isOpen={dialog.open}
        onClose={closeDialog}
        onSaved={() => setRefreshKey((k) => k + 1)}
        defaultValues={dialog.item ?? undefined}
      />
    </Box>
  );
}
